/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */

import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
import '../behaviors/keyboard-accessibility.js';
import '../../crp_transfer_ui/behaviors/authAndSubmitCorp.js';
import '../../crp_meta_ui/elements/error-component.js';
import './app-message-handler.js';
const template = html`
<style include="corp-app-styles">
paper-icon-button[aria-label="Back"][phone]{
    right:12px;
}
 
.button-bottom{
    display: flex;
    flex-direction: column;
    height: calc(100vh - 65px);
    /*justify-content: space-between;*/
}
paper-dialog#billerServicesModal{
    left: 30%;
    /* max-height: 340px;
    max-width: 563px; */
    width : 35%;
    height : auto;
    padding-bottom:20px;

} 
paper-dialog#billerServicesModal .close-icon{
    position: absolute;
    right: 0;
    top: 10px;
    color: #00839B;
}
.popup-border{
    border-bottom: 1px solid #DFE1E6;
}
</style>

 
<app-media-query phone="{{phone}}" tablet="{{tablet}}" desktop="{{desktop}}"></app-media-query>
    <div style="margin:20px;"><error-component></error-component></div> 
<div class="commonMargin">
    <div class="content-align-center font-size-xxl font-weight-bold margin-t-b-2 text-align-center" >
        <oe-i18n-msg  id=" " msgid="l_authenticationModePreference"></oe-i18n-msg> 
    </div>
    <div class="light-background margin-b-zero" style="padding: 25px 35px;">
        <div class="vertical layout">
            <div>
                <div class="font-size-l font-weight-bold mdl-cell mdl-cell--6-col">
                    <oe-i18n-msg  id=" " msgid="l_authMode1"></oe-i18n-msg> 
                </div>
                <div class="mdl-cell mdl-cell--6-col">
                    <oe-combo class="commonOEComboNoFloatLabel" id="authmode1" label=" " required listdata={{authModeList}} 
                                        displayproperty="codeDescription" valueproperty="cmCode" value={{authenticationMode1}} no-label-float>
                                        </oe-combo>
                </div>
                <div class="mdl-grid"></div>
            </div>
            <div>
                <div class="font-size-l font-weight-bold mdl-cell mdl-cell--6-col">
                    <oe-i18n-msg  id=" " msgid="l_authMode2"></oe-i18n-msg> 
                </div>
                <div class="mdl-cell mdl-cell--6-col">
                    <oe-combo class="commonOEComboNoFloatLabel" id="authmode2" label=" " required listdata={{authModeList}} 
                                        displayproperty="codeDescription" valueproperty="cmCode" value={{authenticationMode2}} no-label-float>
                                        </oe-combo>
                </div>
                <div class="mdl-grid"></div>
            </div>
            <div>
                <div class="font-size-l font-weight-bold mdl-cell mdl-cell--6-col" >
                    <oe-i18n-msg  id=" " msgid="l_authMode3"></oe-i18n-msg> 
                </div>
                <div class="mdl-cell mdl-cell--6-col">
                    <oe-combo class="commonOEComboNoFloatLabel" id="authmode3" label=" " required listdata={{authModeList}} 
                                        displayproperty="codeDescription" valueproperty="cmCode" value={{authenticationMode3}} no-label-float>
                                        </oe-combo>
                </div>
                <div class="mdl-grid"></div>
            </div>
        </div>
    </div>
    <div class="light-background content-align-horizontal-end" style="margin-top:2px !important;padding:25px;">
        <div class="mdl-cell mdl-cell--3-col"><paper-button id=" " raised class="primary-medium-button" on-tap="_proceed" disabled={{!changeFlag}} style="width:-webkit-fill-available;">
            <oe-i18n-msg msgid="b_Proceed"></oe-i18n-msg>
        </paper-button></div>
    </div> 
    <!--<app-message-handler duration="2000" persist-on="error"></app-message-handler>-->
     
    <paper-dialog id="billerServicesModal" class="paper-dialog" modal backdrop>
        <div class="mdl-grid  mdl-cell--12-col" style="border-bottom: 1px solid teal;">
            <div class="content-align-center margin-b-zero margin-t-zero mdl-cell mdl-cell--11-col"  >
                <oe-i18n-msg msgid="b_Success"></oe-i18n-msg>
            </div>
            <div class="content-align-center  mdl-cell--1-col" >
                <paper-icon-button class="teal-color iron-icon-style-l" icon="close" dialog-dismiss on-tap="_closedialog"></paper-icon-button>
            </div> 
        </div>
        <div class = "content-align-center font-18 mdl-cell mdl-cell--12-col mdl-grid padding-zero">
        <oe-i18n-msg msgid="{{successMsg}}"></oe-i18n-msg>
        </div> 
    </paper-dialog>
</div> 
<!--
<div class="mdl-cell mdl-cell--3-col"><paper-button id=" " raised class="primary-button" on-tap="_authmode" style="width:-webkit-fill-available;height:40px;">
            <oe-i18n-msg msgid="b_Proceed"></oe-i18n-msg>
        </paper-button></div>
        <div class="mdl-cell mdl-cell--3-col"><paper-button id=" " raised class="primary-button" on-tap="_back" style="width:-webkit-fill-available;height:40px;">
            <oe-i18n-msg msgid="back"></oe-i18n-msg>
        </paper-button></div>
        -->





`;
Polymer({
    is: "corporate-authentication-preference",
    behaviors: [sbBehavioursCorp.authAndSubmitCorp, accessibilityBehaviours.commonFunctions, corpBehaviours.corporateDateFormatBehaviour],
    _template: template,
    properties: {
        leftAction: {
            type: Object,
            notify: true
        },
        rightAction: {
            type: Object,
            notify: true
        },
        selectedPage: {
            type: Number,
            notify: true,
            value:0
        },
        swipedLeft: {
            type: Boolean,
            notify: true,
            observer: '_swipedLeftInvoked'
        },
        userId: {
            type: String,
            notify: true,
            value: () => {
                    return clientStorage.get(storageType.session, 'userId');
                }
          },
          AuthenticationObj: {
            type: Object,
            notify: true,
            observer:'_setAuthMode'
          },
          authenticationMode1: {
            type: String,
            notify: true,
            value:"",
            observer:'_valueChanged'
        },
        authenticationMode2: {
            type: String,
            notify: true,
            value:"",
            observer:'_valueChanged'
        },
        authenticationMode3: {
            type: String,
            notify: true,
            value:"",
            observer:'_valueChanged'
        },
        authModeList: {
			type: Array,
			notify: true,
            value:[]
		},
        changeFlag: {
            type: Boolean,
            notify: true,
            value:false
        },
        successMsg: {
            type: String,
            notify: true,
            value:"" 
        }
    } 
    ,
    _setAuthMode(){
        this.authModeList=this.AuthenticationObj.authenticationModesList;
        this.authenticationMode1=this.AuthenticationObj.authenticationModesList[0].cmCode;
        this.authenticationMode2=this.AuthenticationObj.authenticationModesList[1].cmCode;
        this.authenticationMode3=this.AuthenticationObj.authenticationModesList[2].cmCode;
    },
    _valueChanged(){
        if(this.authModeList!=undefined && this.authModeList.length !=0){
                if (this.authenticationMode1!=this.authModeList[0].cmCode || this.authenticationMode2!=this.authModeList[1].cmCode ||this.authenticationMode3!= this.authModeList[2].cmCode){
                    this.changeFlag=true;
                }
                else{
                    this.changeFlag=false;
                }
            }
        },
    _proceed(){
        if(this.authenticationMode1 == this.authenticationMode2){
            this.fire("call-error", getLabel("l_authModeValidation"));
        }
        else if(this.authenticationMode1 == this.authenticationMode3){
            this.fire("call-error", getLabel("l_authModeValidation"));
        }
        else if(this.authenticationMode2 == this.authenticationMode3){
            this.fire("call-error", getLabel("l_authModeValidation"));
        }
        else {
            var self = this;
                var ajaxCall = document.createElement('oe-ajax');
                ajaxCall.contentType = "application/json";
                ajaxCall.handleAs = "json"; 
                ajaxCall.url ="api/CBUsers/"+clientStorage.get(storageType.session, 'userId')+"/changeauthenticationmode"; 
                ajaxCall.method = "post";
                ajaxCall.body ={
                    "authenticationMode1" : self.authenticationMode1,
                    "authenticationMode2" : self.authenticationMode2,
                    "authenticationMode3" : self.authenticationMode3
                };
                ajaxCall.addEventListener('error', function (err) {
                    self.ErrMsg = "";
                    //self.ErrMsg = err.detail.request.response.error.message.status != undefined ? err.detail.request.response.error.message.status.message[0].messageDesc : err.detail.request.response.error.message;
                    self.ErrMsg = JSON.parse(err.detail.request.response.error.message.channelcontext).status != undefined ? JSON.parse(err.detail.request.response.error.message.channelcontext).status.message[0].messageDesc : err.detail.request.response.error.message;
                    self.dispatchEvent(new CustomEvent('oe-show-error', {
                        bubbles: true,
                        composed: true,
                        detail: {
                            message: self.ErrMsg
                        }
                    }));

                });
                ajaxCall.addEventListener('response', function (e) {
                    var AuthenticationObj= e.detail.response;
                    self.AuthenticationObj= AuthenticationObj;
                    self.changeFlag=false;
                    var responseHeader = JSON.parse(e.detail.__data.xhr.getResponseHeader('channelcontext')); 
                    //var msg =responseHeader.status.message[0].messageDesc;
                    self.successMsg=responseHeader.status.message[0].messageDesc;
                    self._proceeddialog();
                    self.autoCloseFunction();
                    //this.fire('oe-show-message',msg);
                    //var event = new CustomEvent('oe-show-message', {detail: msg });
                    //window.dispatchEvent(event);
                    // window.oe_navigate_to("/corpauthenticationpreference", {
                    //     'AuthenticationObj': AuthenticationObj
                    // });
                });
                oeAjaxEventListner(ajaxCall);
                ajaxCall.generateRequest();
        }
    },
    _proceeddialog(){
        this.$.billerServicesModal.open();
    },
    _closedialog(){
        this.$.billerServicesModal.close();
    },
    autoCloseFunction(){
        var self = this;
            setTimeout(function () {
                self._closedialog();
            }, 1000 * 3)
        } 
});